module.exports = __webpack_public_path__ + "img/epk-photo-2.49a3cd79.jpg";